<template>
	<div class="main-container">
		<div class="filter-result background-white box-shadow-small border-radius" v-loading="partialLoading">
			<div class="filter-result-header mb-20">
				<el-button type="primary" @click="$router.push({name: 'paymentRuleDetail', params: {id: 'create'}})">新增规则</el-button>
			</div>
			<empty-tip :show="!lists.length"></empty-tip>
			<div class="table-list">
				<el-table v-if="lists.length" :data="lists" style="width: 100%">
					<el-table-column prop="name" label="规则名称" align="center"></el-table-column>
					<el-table-column prop="state" label="状态" align="center">
						<template slot-scope="scope">
							<span>{{scope.row.state == 1 ? '启用' : '停用'}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="updateTime" label="最后修改时间" align="center"></el-table-column>
					<el-table-column prop="modifyUserName" label="最后修改人" align="center"></el-table-column>
					<el-table-column prop="id" label="操作" align="center">
						<template slot-scope="scope">
							<el-button size="small" @click="$router.push({name: 'paymentRuleDetail', params: {id: scope.row.id}})">编辑</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<el-pagination
					v-if="lists.length"
					class="text-center mb-20 mt-20"
					@size-change="pageSizeChange"
					@current-change="pageIndexChange"
					:current-page="pagination.pageIndex"
					:page-size="pagination.pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="pagination.recordCounts">
			</el-pagination>
		</div>
	</div>
</template>

<script type="text/javascript">
import QueryListExtend from 'components/queryListExtend'
import selectMapMixin from 'mixins/selectMapMixin'
import queryListMixin from '../operation/queryListMixin'
import { dateFormat } from 'modules/tools'

export default {
    'extends': QueryListExtend,
    'mixins': [selectMapMixin, queryListMixin],
    data () {
        return {
            fetchUrl: '/payment/template/list.api'
        }
    },
    created () {
        console.log('create')
    },
    methods: {
        dateFormat (date, format = 'yyyy/MM/dd') {
            return dateFormat(date, format)
        }
    }
}
</script>



// WEBPACK FOOTER //
// salaryRuleList.vue?fbe708b0